import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />

      <div className="max-w-5xl mx-auto px-6 py-12 bg-white shadow-lg rounded-xl">
        <h1 className="text-4xl font-bold mb-8 text-center text-gray-900">
          Privacy Policy
        </h1>

        <p className="mb-6 text-gray-700 leading-relaxed">
          At <strong>ZajraGreen</strong>, we respect your privacy and are committed
          to protecting the personal information you share with us. This Privacy
          Policy explains how we collect, use, and safeguard your data when you
          interact with our website or services.
        </p>

        <div className="space-y-6">
          <div>
            <h2 className="text-2xl font-semibold mb-2 text-gray-800">
              Information We Collect
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We may collect personal details such as your name, phone number,
              email address, project location, and service requirements when you
              contact us, submit inquiries, or request quotations.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-2 text-gray-800">
              How We Use Your Information
            </h2>
            <p className="text-gray-700 leading-relaxed">
              The information collected is used to respond to inquiries, provide
              project consultations, deliver turf and sports infrastructure
              services, and improve our offerings and customer experience.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-2 text-gray-800">
              Data Protection
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We take appropriate technical and organizational measures to
              safeguard your data against unauthorized access, misuse, or
              disclosure.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-2 text-gray-800">
              Sharing of Information
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We do not sell or rent your personal information. Data may only be
              shared with trusted partners or contractors when necessary to
              execute a project or service, and only for that purpose.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
